/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_oauth_complete_subtitle_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can switch back to Minecraft now.`)
};

const zh_hans1_oauth_complete_subtitle_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`现在可以切回 Minecraft 了。`)
};

const zh_hant1_oauth_complete_subtitle_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你可以關閉此視窗，稍後將返回 Minecraft。`)
};

const fr_oauth_complete_subtitle_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous pouvez revenir à Minecraft maintenant.`)
};

const de_oauth_complete_subtitle_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kannst jetzt zurück zu Minecraft wechseln.`)
};

const ja_oauth_complete_subtitle_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft に戻っても大丈夫です。`)
};

const ko_oauth_complete_subtitle_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브라우저 창을 닫아도 됩니다. 곧 Minecraft로 돌아갑니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const oauth_complete_subtitle_minecraft = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.oauth_complete_subtitle_minecraft(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("oauth_complete_subtitle_minecraft", locale)
	if (locale === "en") return en_oauth_complete_subtitle_minecraft(inputs)
	if (locale === "zh-Hans") return zh_hans1_oauth_complete_subtitle_minecraft(inputs)
	if (locale === "zh-Hant") return zh_hant1_oauth_complete_subtitle_minecraft(inputs)
	if (locale === "fr") return fr_oauth_complete_subtitle_minecraft(inputs)
	if (locale === "de") return de_oauth_complete_subtitle_minecraft(inputs)
	if (locale === "ja") return ja_oauth_complete_subtitle_minecraft(inputs)
	return ko_oauth_complete_subtitle_minecraft(inputs)
};